import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { Intent } from '../../@types/intent'
import { updateIntent } from '../../store/lead/leadSlice'
import { Progress } from '../../@types/progress'
import { useReportViewEvent } from '../../hooks'
import { getCustomDimensionForIntent } from '../../tracking/tracking'
import { reportTrackingEvent } from '../../tracking/thunks'
import { Button } from '../../components/styled/CosmaButton/CosmaButton'
import { IntegrationType } from '../../@types/config'
import { DevComStepIcon } from '../../components/icons/StepIcons/DevComStepIcon'
import { ReduxState } from '../../store/reducers'
import './DevComStep.scss'

const tinyColor = require('tinycolor2')

interface DevComStepProps {
  goToNextStep: () => unknown
  goToPreviousStep: () => unknown
  progress: Progress
  displayBack: boolean
}
const headline = 'Käufer für Ihr Grundstück finden'
const subLine = (
  <div className='status-tertiary-text align-center one-third head-sub-text mr-auto'>
    Wir finden passende Käufer für Ihr Grundstück, damit Sie ohne Aufwand und zum attraktiven Preis verkaufen können.
  </div>
)

export const DevComStep: FC<DevComStepProps> = (props) => {
  useReportViewEvent({ pageTitle: 'offer' })
  const {
    config: { theme, integrationType, illustration },
  } = useSelector((state: ReduxState) => state)
  const showHighlighter =
    !(integrationType === IntegrationType.EXTERNAL) && !(integrationType === IntegrationType.IMMOVERKAUF24)

  const dispatch = useDispatch()

  const goToNextStep = (intent: Intent) => {
    dispatch(updateIntent(intent))
    props.goToNextStep()
    const label = intent === Intent.INDEPENDENT_WITH_OFFER_SALE ? 'offer-opt-in' : 'offer-opt-out'
    dispatch(
      reportTrackingEvent({
        label: label,
        pageTitle: 'offer',
        category: 'residential',
        action: 'realtor-leadengine',
        inputValue: label,
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: getCustomDimensionForIntent(intent),
        },
      })
    )
  }

  return (
    <StepTemplate
      icon={<DevComStepIcon />}
      headline={headline}
      subLine={subLine}
      displayNext={false}
      goToPreviousStep={props.goToPreviousStep}
      progress={props.progress}
      displayBack={props.displayBack}
      className='devcom-offer'
      backgroundColor={theme.background}
      textColor={theme.text}
      illus={illustration}
    >
      <div className='grid-item align-center d-flex justify-center'>
        <div
          className={`${showHighlighter ? 'highligher-area highlighter-bold' : ''}`}
          data-testid='devCom-highlighter'
        >
          <div className='highlighter-text'>
            <i className='is24-icon-advertising' />
            <span>Kostenlos & unverbindlich</span>
          </div>
        </div>
      </div>
      <div className={`grid-item one-whole`}>
        <div className='grid-item one-whole'>
          <div className='details-holder one-half mr-auto status-holder justify-center padding-bottom-xxl'>
            <ul className='status-list list-check'>
              <li>
                <span className='status-primary-text header-text'>Verkauf ohne Makler</span>
              </li>
              <li>
                <span className='status-primary-text'>Angebote direkt erhalten</span>
              </li>
              <li>
                <span className='status-primary-text'>Hohen Verkaufspreis erzielen</span>
              </li>
            </ul>
          </div>
        </div>
        <div className='grid-item one-whole margin-top-xxl align-center mr-auto status-btn'>
          <Button
            onClick={() => goToNextStep(Intent.INDEPENDENT_WITH_OFFER_SALE)}
            appearance='primary'
            primary={theme.primary}
            textColor={!showHighlighter && tinyColor(theme.primary).isDark() ? '#FFFFFF' : theme.text}
            secondaryLight={theme.secondaryLight}
          >
            Angebote vergleichen
          </Button>
        </div>
        <div className='grid-item one-whole margin-top-m align-center'>
          <a
            href='#/'
            onClick={() => goToNextStep(Intent.INDEPENDENT_SALE)}
            style={{ color: integrationType === IntegrationType.IMMOVERKAUF24 ? '#2780ba' : '#2267e8' }}
          >
            Ich habe kein Interesse
          </a>
        </div>
      </div>
    </StepTemplate>
  )
}

export default DevComStep
